import React from 'react';
import '../styles/EndDialog.css';

interface EndDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const EndDialog: React.FC<EndDialogProps> = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="timer-dialog-overlay">
      <div className="timer-dialog">
        <div className="timer-header">
          <h2>End Game</h2>
          <button className="close-button" onClick={onCancel}>×</button>
        </div>

        <div className="timer-content">
          <div className="end-message">
            Are you sure you want to end the game?
          </div>

          <div className="timer-buttons">
            <button 
              className="timer-button confirm"
              onClick={onConfirm}
            >
              Yes, End Game
            </button>
            <button 
              className="timer-button cancel"
              onClick={onCancel}
            >
              No, Continue Playing
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EndDialog; 